import checkEnvironment from '../../../ui-common/src/lib/checkEnvironment';

const getGatewayApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/logms/logsearch`;
};

export default getGatewayApiUrl;
